// store/modules/user.js

const state = {
  exhibition: {},
};

const mutations = {
  SET_EXHIBITION(state, exhibition) {
    state.exhibition = exhibition;

    localStorage.setItem("exhibition", JSON.stringify(exhibition));
  },
  REMOVE_EXHIBITION(state) {
    state.exhibition = {};
    localStorage.removeItem("exhibition");
  },
  INIT(state) {
    state.exhibition = localStorage.getItem("exhibition")
      ? JSON.parse(localStorage.getItem("exhibition"))
      : {};
  },
};

const actions = {};

const getters = {
  exhibition: (state) => state.exhibition,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
